import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import type { Module } from '../../../features/admin/modules/modules.model';
import { UserStore } from 'app/core/services/user.store';
import { ModulesStore } from '../../../features/admin/modules/modules.store';

@Directive({
  selector: '[canViewPage]',
  standalone: true,
})
export class CanViewPageDirective {
  canViewPage = input<{ pageId: Module['id']; show: boolean }>();
  isHidden = true;

  userStore = inject(UserStore);
  modulesStore = inject(ModulesStore);

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    effect(() => {
      if (this.userStore.currentUser() || this.canViewPage()) {
        this.updateView();
      }
    });
  }

  private updateView() {
    if (this.canViewPageCheck() && this.isHidden) {
      if (this.isHidden && this.canViewPage().show) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.isHidden = false;
      } else if (!this.canViewPage().show) {
        this.isHidden = true;
        this.viewContainer.clear();
      }
    } else if (!this.canViewPageCheck()) {
      if (!this.canViewPage().show && this.isHidden) {
        this.isHidden = false;
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else if (this.canViewPage().show) {
        this.isHidden = true;
        this.viewContainer.clear();
      }
    }
  }

  private canViewPageCheck() {
    const module = this.modulesStore.getModuleById(this.canViewPage().pageId);
    if (module?.isPublic) {
      return true;
    }

    return this.userStore.checkIfHasReadPermission(this.canViewPage().pageId);
  }
}
